import type { ProfileFormErrors, ProfileFormFields, ProfileFormLoading } from './schema';
import { profileFormState } from './store';

export const setField = <FieldKey extends keyof ProfileFormFields>(
  name: FieldKey,
  value: ProfileFormFields[FieldKey],
) => {
  profileFormState.fields[name] = value;
};

export const setError = <FieldKey extends keyof ProfileFormErrors>(
  name: FieldKey,
  value: string,
) => {
  profileFormState.errors[name] = value;
};

export const setLoadingField = <FieldKey extends keyof ProfileFormLoading>(
  name: FieldKey,
  value: boolean,
) => {
  profileFormState.loading[name] = value;
};

export const clearErrorField = <FieldKey extends keyof ProfileFormErrors>(name: FieldKey) => {
  profileFormState.errors[name] = null;
};

export const clearErrors = () => {
  profileFormState.errors = {
    displayName: null,
    bio: null,
    avatarUploadKey: null,
    coverImageUploadKey: null,
    spotifyUrl: null,
    tiktokUrl: null,
    delegateWallet: null,
  };
};

export const clearFields = () => {
  profileFormState.fields = {
    displayName: null,
    bio: null,
    avatarUploadKey: null,
    coverImageUploadKey: null,
    spotifyUrl: null,
    tiktokUrl: null,
    delegateWallet: null,
    invitedByUserId: null,
  };
};
